import gql from 'graphql-tag'

import { CredentialsFieldsFragment } from '../credentials'
import { FamilyFieldsFragment } from '../family'
import { UserFieldsFragment } from './user'

export const CREATE_PARENT_USER_MUTATION = gql`
  mutation CreateParentUser($user: CreateParentUserParams!) {
    createParentUser(user: $user) {
      user {
        ...UserFields
        family {
          ...FamilyFields
        }
      }
      credentials {
        ...CredentialsFields
      }
    }
  }

  ${CredentialsFieldsFragment}
  ${FamilyFieldsFragment}
  ${UserFieldsFragment}
`
